export default __webpack_public_path__ + "static/media/result.de51fc76.png";